module.exports = __webpack_public_path__ + "static/media/full-logo.44bfa357.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/full-logo.png
// module id = 176
// module chunks = 0